import React from "react";

type Props = {
  isServiceProviderAccount?: boolean;
};

export const FormNotice: React.FC<Props> = ({
  isServiceProviderAccount = false,
}) => {
  return (
    <div className="notification content">
      <h3 className="title is-5">手続き情報の編集について</h3>
      <ul>
        <li>
          保存した内容は、即時にページへ反映されるので、注意してください。
        </li>
        {isServiceProviderAccount && (
          <>
            <li>
              ステータスの変更、公開手続きの編集、グループの紐付け変更は、テナントユーザーのみ可能です。
            </li>
          </>
        )}
        <li>
          <span className="icon has-text-danger is-size-7">
            <i className="fas fa-asterisk" />
          </span>
          がついている項目の入力は、公開時には必須です。
        </li>
      </ul>
    </div>
  );
};

export default FormNotice;
